import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import indexedDBStorage, { deleteDB } from './indexeddb-storage';
// slices
import productsReducer from './slice/product';
import checkoutReducer from './slice/checkout';
import customerReducer from './slice/customer';
import invoiceReducer from './slice/invoice';
import userReducer from './slice/user';
import supplyReducer from './slice/supply';
import cashRegisterReducer from './slice/cashRegister';
import voucherReducer from './slice/voucher';

// Clear localStorage data for cashRegister when switching to IndexedDB
const clearLocalStorageForCashRegister = () => {
  try {
    localStorage.removeItem('redux-cashRegister');
  } catch (error) {
    console.warn('Failed to clear localStorage for cashRegister:', error);
  }
};

// Clear localStorage data for checkout when switching to IndexedDB
const clearLocalStorageForCheckout = () => {
  try {
    localStorage.removeItem('redux-checkout');
  } catch (error) {
    console.warn('Failed to clear localStorage for checkout:', error);
  }
};

// Clear localStorage data for customers when switching to IndexedDB
const clearLocalStorageForCustomers = () => {
  try {
    localStorage.removeItem('redux-customers');
  } catch (error) {
    console.warn('Failed to clear localStorage for customers:', error);
  }
};

// Clear localStorage data for users when switching to IndexedDB
const clearLocalStorageForUsers = () => {
  try {
    localStorage.removeItem('redux-users');
  } catch (error) {
    console.warn('Failed to clear localStorage for users:', error);
  }
};

// Clear localStorage data for supplies when switching to IndexedDB
const clearLocalStorageForSupplies = () => {
  try {
    localStorage.removeItem('redux-supplies');
  } catch (error) {
    console.warn('Failed to clear localStorage for supplies:', error);
  }
};

// Clear localStorage data for invoices when switching to IndexedDB
const clearLocalStorageForInvoices = () => {
  try {
    localStorage.removeItem('redux-invoices');
  } catch (error) {
    console.warn('Failed to clear localStorage for invoices:', error);
  }
};

// Clear localStorage data for products when switching to IndexedDB
const clearLocalStorageForProducts = () => {
  try {
    localStorage.removeItem('redux-products');
  } catch (error) {
    console.warn('Failed to clear localStorage for products:', error);
  }
};

// Call this once when the module loads
clearLocalStorageForCashRegister();
clearLocalStorageForCheckout();
clearLocalStorageForCustomers();
clearLocalStorageForInvoices();
clearLocalStorageForUsers();
clearLocalStorageForSupplies();
clearLocalStorageForProducts();
const clearLegacyResult = deleteDB('pos360');
if (clearLegacyResult && typeof clearLegacyResult.then === 'function') {
  clearLegacyResult.then();
}

// ----------------------------------------------------------------------

const productsPersistConfig = {
  key: 'products',
  storage: indexedDBStorage,
  keyPrefix: 'redux-',
  blacklist: ['isLoading', 'isValidating', 'error'], // Exclude loading states from persistence
};

const checkoutPersistConfig = {
  key: 'checkout',
  storage: indexedDBStorage,
  keyPrefix: 'redux-',
};

const customersPersistConfig = {
  key: 'customers',
  storage: indexedDBStorage,
  keyPrefix: 'redux-',
};

const invoicesPersistConfig = {
  key: 'invoices',
  storage: indexedDBStorage,
  keyPrefix: 'redux-',
  blacklist: ['isLoading', 'error'], // Exclude loading states from persistence
};

const usersPersistConfig = {
  key: 'users',
  storage: indexedDBStorage,
  keyPrefix: 'redux-',
};

const suppliesPersistConfig = {
  key: 'supplies',
  storage: indexedDBStorage,
  keyPrefix: 'redux-',
};

const cashRegisterPersistConfig = {
  key: 'cashRegister',
  storage: indexedDBStorage,
  keyPrefix: 'redux-',
  blacklist: ['transactions'], // Exclude large transaction arrays from persistence
};

const voucherPersistConfig = {
  key: 'voucher',
  storage: indexedDBStorage,
  keyPrefix: 'redux-',
  blacklist: ['isLoading', 'error'], // Exclude loading states from persistence
};

export const rootReducer = combineReducers({
  products: persistReducer(productsPersistConfig, productsReducer),
  checkout: persistReducer(checkoutPersistConfig, checkoutReducer),
  customers: persistReducer(customersPersistConfig, customerReducer),
  invoices: persistReducer(invoicesPersistConfig, invoiceReducer),
  user: persistReducer(usersPersistConfig, userReducer),
  supply: persistReducer(suppliesPersistConfig, supplyReducer),
  cashRegister: persistReducer(cashRegisterPersistConfig, cashRegisterReducer),
  voucher: persistReducer(voucherPersistConfig, voucherReducer),
});
